import React from 'react';
import { displayName } from '../../../App';
import MainGuidanceLayout from '../../components/Layout/Main';
import Content from '../../components/Pages/Taxes';

function Taxes() {
  document.title = `${displayName}: eTax`;

  return (
    <MainGuidanceLayout>
      <Content />
    </MainGuidanceLayout>
  );
}

export default Taxes;
